import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "M29.871 20.457c1.042-1.406 1.592-2.269 1.65-2.588.06-.319.219-.7.479-1.142h-3.965l-.156.507a8.655 8.655 0 0 1-.215.645c-.195.39-.436.814-.723 1.27-.286.455-.592.882-.918 1.279a10.22 10.22 0 0 1-.976 1.045c-.326.286-.619.462-.879.527-.508.117-.781-.26-.82-1.133-.04-.872-.04-1.569 0-2.09.026-.481.039-.826.039-1.035 0-.208-.007-.351-.02-.43a.536.536 0 0 0-.176-.312.566.566 0 0 0-.312-.137 14.81 14.81 0 0 0-1.035-.107c-.43-.033-.905-.036-1.426-.01l-.918.04c.182.403.335.637.459.702.124.065.218.332.283.801.078.547.069 1.312-.03 2.295-.097.983-.419 1.475-.966 1.475-.43 0-.866-.274-1.308-.82a12.9 12.9 0 0 1-1.182-1.807 20.023 20.023 0 0 1-.889-1.826c-.221-.56-.338-.853-.351-.88H12l.313.801c.65 1.615 1.34 3.021 2.07 4.22.742 1.197 1.533 2.193 2.373 2.987.84.795 1.741 1.4 2.705 1.817a9.407 9.407 0 0 0 3.105.703l.586.02.04-.567c.025-.43.146-.889.36-1.377.216-.488.518-.732.909-.732.56 0 .973.094 1.24.283.267.189.59.517.967.986.365.443.706.788 1.025 1.035.32.248.772.371 1.358.371H32l-.43-.84a6.842 6.842 0 0 0-1.289-1.806c-.534-.54-.93-.98-1.191-1.318a1.59 1.59 0 0 1-.235-.46c-.065-.188-.045-.4.06-.634.077-.209.214-.495.41-.86.195-.364.377-.664.546-.898Z"
    }, null, -1)
  ]))]))
}
export default { render: render }